import {
  GET_GROUP_PLANS,
  GET_GROUP_PLANS_SUCCESS,
  GET_GROUP_PLANS_FAILURE,
  SELECT_GROUP_PLAN,
} from './types'

export const getGroupPlans = () => ({
  type: GET_GROUP_PLANS,
})

export const getGroupPlansSuccess = (plans: any) => ({
  type: GET_GROUP_PLANS_SUCCESS,
  payload: {
    plans,
  },
})

export const getGroupPlansFailure = (errorMessage: string) => ({
  type: GET_GROUP_PLANS_FAILURE,
  payload: {
    errorMessage,
  },
})

export const selectGroupPlan = (planId: string) => ({
  type: SELECT_GROUP_PLAN,
  payload: { planId },
})
